import { createFileRoute } from "@tanstack/react-router";
interface RegisterRequest {
  idToken: string;
}
interface GoogleTokenPayload {
  email: string;
  email_verified: boolean;
  sub: string;
  name?: string;
}
export const Route = createFileRoute("/api/android-beta/register")({});